
const state = {
    errorResponse: undefined
};

const mutations = { 
    setErrorResponse(state, data){
        state.errorResponse = {...data};
    },
    cleanErrorResponse(state){
        state.errorResponse = undefined;
    }
};

const actions = { 
    setErrorResponse({commit}, data){
        const {status, message} = data;
        commit('setErrorResponse',{status, message});
    },
    cleanErrorResponse({commit}){
        commit('cleanErrorResponse');
    }
};

const getters = { 
    errorResponse: (state) => state.errorResponse
};

export default {
    state,
    mutations,
    actions,
    getters
}